import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ReadMoreIcon } from "../Pages/Header/Icon";
import ArrowRight, { IconPayment, IconZakat } from "../Icons/Icon";
import { IoMdArrowRoundForward } from "react-icons/io";
import { motion } from "framer-motion";

export function DonateButton({ isFull = false, link,center  }) {
  
  const { t } = useTranslation();


  const donateLink=process.env.REACT_APP_DONATE_URL;

  return (
    <div>
      <Link to={donateLink} target="_blank"  className={`bg-[#15803d] hover:shadow-md hover:shadow-[#15803d]/50 duration-700 ${center && "text-center flex justify-center"} ${isFull && "w-full"} text-white py-2 px-4 rounded-md flex gap-3`}>
        {t("donate")}
        <IconPayment/>
      </Link>
    </div>
  );
}

export function SeeMore({link}) {
  const { t,i18n } = useTranslation();
  return (
    <Link
      to={link}
      className="group relative inline-flex items-center mt-5 md:mt-0 justify-center overflow-hidden rounded-lg bg-[#15803d] px-8 py-3.5 font-medium text-white shadow-lg transition-all duration-300 ease-out hover:scale-105 hover:shadow-xl hover:shadow-[#15803d]/50 active:scale-95"
      aria-label="View Gallery"
    >
      <span className="absolute top-0 left-0 h-full w-full bg-[length:400%] bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-50 transition-all duration-1000 ease-out group-hover:left-[100%]"></span>
      <span className="relative flex items-center gap-2">
        <span className="tracking-wide">{t("seeMore")}</span>
        <span className={` ${i18n.language=="ar" || i18n.language=="ckb" ?"rotate-180":""} transition-transform duration-300 group-hover:translate-x-1`  }>

          <IoMdArrowRoundForward />

        </span>
      </span>
    </Link>
  );
}

export function ReadMore({link}) {
  const { t,i18n } = useTranslation();
  return (
    <div className="border-t border-gray-200 pt-2 mt-3">
    <Link
      to={link}
      className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold"
    >
      <span>{t("readMore")}</span>
      <div
        className={`${
          i18n.language === "ar" || i18n.language === "ckb"
            ? "rotate-180"
            : ""
        }`}
      >
        <ReadMoreIcon />
      </div>
    </Link>
  </div>
  )}

export function ZakatButton({ isFull = false , link,marginTop="mt-0"}) {
  const navigate=useNavigate();
  const { t ,i18n} = useTranslation();
  return (
    <div>
      <button onClick={()=>navigate(link)} className={`bg-slate-950 ${marginTop } flex justify-between hover:shadow-md hover:shadow-slate-950/50 duration-700 ${isFull && "w-full"} text-white py-2 px-4 rounded-md flex gap-3`}>
        { i18n?.language=="ckb"? t("zakat"): t("ZakatCalculator")} 
        <IconZakat/>
      </button>
    </div>
  );
}